import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kt-authcallback',
  templateUrl: './authcallback.component.html',
  styleUrls: ['./authcallback.component.scss']
})
export class AuthcallbackComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
